import { Typography } from '@mui/material';
import ProductTourContent from 'src/components/ProductTourContent';
import { IProductTour } from 'src/models/productTour';

export const CustomDashboardStep: IProductTour = {
  title: 'Create Your First Custom Dashboard',
  menu: 'customization',
  submenu: 'custom-dashboard',
  steps: [
    {
      title: "Let's Create Your Custom Dashboard!",
      content: (
        <ProductTourContent spacing={1}>
          A custom dashboard is a great way to personalize your metrics quickly
          and easily.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Start the Tour'
    },
    {
      title: 'Open Dashboard Menu',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Click here to open the customization dashboard menu.
        </ProductTourContent>
      )
    },
    {
      title: 'Create New Dashboard',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          You can add custom dashboard here (click the button).
        </ProductTourContent>
      )
    },
    {
      title: 'Create New Dashboard',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          <Typography fontSize="12px">
            Type your new dashboard name, select the source type, and click
            <strong> Next </strong>
            to continue.
          </Typography>
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Select Objects or Group',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Add object or group to visualize your data on your dashboard for the
          better insights. For now, let's select objects.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Select Objects',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Select any objects you want to include in your dashboard, then click
          Submit.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Select Objects or Group',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Your objects have been successfully added. Click Submit to go to the
          next step.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Click on Manage Widget',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Click here to arrange the widgets in your dashboard.
        </ProductTourContent>
      )
    },
    {
      title: 'Choosing your metrics & widgets',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Choose your preferred widget from various display types and arrange it
          as you like.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Adjust Timeframe',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Adjust the timeframe to your preference here.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Download Report',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Click here to download your report or create white-labeled reports.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'The Final Step',
      content: (
        <ProductTourContent spacing={2}>
          All steps are complete. You've successfully finished this stage and
          are now ready to continue exploring and using all available features.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Finish'
    }
  ]
};
